import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logoMMG.png';
import { BsLinkedin, BsGithub, BsEnvelopeFill } from 'react-icons/bs';
import './navbar.css';

const Navbar = () => {
  return (
    <div className="navbar">
      <img src={logo} alt="Logo" className="logo" />
      <h1 className="fullname">
        <span className="firstName">Maximiliano</span>
        <span className="lastName">Ghirardi</span>
      </h1>
      <div className="separator"></div>
      <ul className="socials">
        <li>
          <a
            href="https://www.linkedin.com/in/maximilianoghirardi"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </a>
        </li>
        <li>
          <a href="https://github.com/mgmaxi" target="_blank" rel="noreferrer">
            <BsGithub />
          </a>
        </li>
        <li>
          <a
            href="mailto:maximiliano.ghirardi@gmail.com?Subject=Portfolio"
            target="_blank"
            rel="noreferrer"
          >
            <BsEnvelopeFill />
          </a>
        </li>
      </ul>
      <div className="separator"></div>
      <ul className="sections">
        <li>
          <Link to="/">About</Link>
        </li>
        <li>
          <Link to="/projects">Projects</Link>
        </li>
        <li>
          <Link to="/technologies">Technologies</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
